export default {
  namespaced: true,
  state: {
    userRefundState: {
      can_repay_current: true,
      can_repay_all: true,
    },
    userRefundPlan: [
      {
        period_no: '1',
        bill_status: '1', // 已还款
        total_amount: '150000', // 应还金额
        already_paid: '0', // 已还金额
        due_time: '1500787486', // 逾期时间戳
        can_pay_time: '2019/03/21', // 还款时间
        overdue_day: '0',
        overdue_fee: '0',
        period_fee_desc: '四月还款费用明细',
        repay_status: '已还款', // 还款状态
        pending_amount: 150000, // 待还款金额
      },
      {
        period_no: '2',
        bill_status: '1', // 已还款
        total_amount: '150000', // 应还金额
        already_paid: '0', // 已还金额
        due_time: '1500787486', // 逾期时间戳
        can_pay_time: '2019/03/21', // 还款时间
        overdue_day: '0',
        overdue_fee: '0',
        period_fee_desc: '四月还款费用明细',
        repay_status: '未还款', // 还款状态
        pending_amount: 150000, // 待还款金额
      },
      {
        period_no: '3',
        bill_status: '1', // 已还款
        total_amount: '150000', // 应还金额
        already_paid: '0', // 已还金额
        due_time: '1500787486', // 逾期时间戳
        can_pay_time: '2019/03/21', // 还款时间
        overdue_day: '0',
        overdue_fee: '0',
        period_fee_desc: '四月还款费用明细',
        repay_status: '已逾期', // 还款状态
        pending_amount: 150000, // 待还款金额
      },
      {
        period_no: '4',
        bill_status: '1', // 已还款
        total_amount: '150000', // 应还金额
        already_paid: '0', // 已还金额
        due_time: '1500787486', // 逾期时间戳
        can_pay_time: '2019/03/21', // 还款时间
        overdue_day: '0',
        overdue_fee: '0',
        period_fee_desc: '四月还款费用明细',
        repay_status: '已还款', // 还款状态
        pending_amount: 150000, // 待还款金额
      },
    ],
  },
  actions: {},
  mutations: {
    test(state) {
      console.log(state);
    },
  },
};
